<template>
    <v-card>
        <v-card v-if="peremesheniho">
      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="peremeshenie"
          :search="search"
          :loading="loading"
                  loading-text="Загрузка. Пожалуйста подождите"
                    :footer-props="{
                        'items-per-page-options': [ 7, 20, 50, 100],
                        'items-per-page-text':'Строк на странице',
                    }"
                    no-data-text="Данные отсутствуют в таблице"
          @dblclick:row="open_peremeshenie"
          class="elevation-1"

          >
          <template v-slot:top>
            <v-toolbar flat color="white">
                <v-toolbar-title>Из магазин на склад</v-toolbar-title>

              <v-col cols="2">
                <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                :return-value.sync="date1"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="date1"
                    label="Дата 1"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    hide-details="auto"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="date1"
                  no-title
                  scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn
                    text
                    color="primary"
                    @click="menu = false"
                  >
                    Отмена
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="filter_per"
                  >
                    OK
                  </v-btn>
                </v-date-picker>
              </v-menu>
             </v-col>

             <v-col cols="2">
                <v-menu
                ref="menu2"
                v-model="menu2"
                :close-on-content-click="false"
                :return-value.sync="date2"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="date2"
                    label="Дата 2"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    hide-details="auto"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="date2"
                  no-title
                  scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn
                    text
                    color="primary"
                    @click="menu2 = false"
                  >
                    Отмена
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="filter_per"
                  >
                    OK
                  </v-btn>
                </v-date-picker>
              </v-menu>
             </v-col>


              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Поиск"
                single-line
                hide-details
                @keypress.enter="search_enter"
              ></v-text-field>
            </v-toolbar>
          </template>



          <template v-slot:no-data>
            <v-btn color="primary" text @click="get_peremeshenie">
              Обновить
            </v-btn>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <v-card v-if="d_peremesheniho">
        <v-card-text>
            <v-data-table
              :headers="d_headers"
              :items="d_peremeshenie"
              :search="search"
              :loading="loading"
                  loading-text="Загрузка. Пожалуйста подождите"
                    :footer-props="{
                        'items-per-page-options': [ 7, 20, 50, 100],
                        'items-per-page-text':'Строк на странице',
                    }"
                    no-data-text="Данные отсутствуют в таблице"
              class="elevation-1"

              >
              <template v-slot:top>
                <v-toolbar flat color="white">
                    <v-btn
                    color="primary"
                    class="mr-4"
                    text
                    @click="back"
                    >
                    <v-icon>mdi-arrow-left</v-icon>
                    </v-btn>

                    <v-toolbar-title>Из магазин на склад</v-toolbar-title>
                    <v-divider
                    class="mx-4"
                    inset
                    vertical
                    ></v-divider>



                  <export-excel
                  :data="d_peremeshenie"
                  :worksheet="'Перемещение'"
                  :name="'Перемещение товар из магазин на склад'"
                  :title="'Перемещение товар из магазин на склад'"
                  :fields="json_fields"
                  :auto-width="true"
                  >
                  <v-icon  color="success" >
                      mdi-microsoft-excel
                      </v-icon>
                </export-excel>



                  <v-spacer></v-spacer>
                  <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Поиск"

                    single-line
                    hide-details
                  ></v-text-field>
                </v-toolbar>
              </template>

              <template v-slot:item.actions="{ item }">
                <v-icon
                  small
                  class="mr-2"
                  @click="editItem(item)"
                >
                  mdi-pencil
                </v-icon>
                <v-icon
                  small
                  @click="deleteItem(item)"
                >
                  mdi-delete
                </v-icon>
                </template>



              <template v-slot:no-data>
                <v-btn color="primary" text @click="get_peremeshenie">
                  Обновить
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
    </v-card>


    <v-dialog
    v-model="delete_dialog"
    max-width="380"
  >
    <v-card>
      <v-card-title >
        Вы уверены что хотите удалить?
      </v-card-title>



      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn
          color="error darken-1"
          text
          @click="delete_dialog = false"
        >
          Отмена
        </v-btn>

        <v-btn
          color="green darken-1"
          text
          @click="delete_confirm"
          :loading="loading"
        >
          Удалить
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog
    v-model="edit_dialog"
    max-width="380"
  >
    <v-card>
      <v-card-title >
        Изменить количество
      </v-card-title>

      <v-card-text>

        <v-text-field
          v-model="edit_count"
          label="Количество"
          type="number"
          required
          :rules="mikdorRules"
        ></v-text-field>

      </v-card-text>



      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn
          color="error darken-1"
          text
          @click="edit_dialog = false"
        >
          Отмена
        </v-btn>

        <v-btn
          color="green darken-1"
          text
          @click="edit_confirm"
          :disabled="!edit_count"
          :loading="loading"
        >
          Изменить
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>


      <v-snackbar
      v-model="snack"
      :timeout="3000"
      :color="snackColor"
     >
      {{ snackText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          v-bind="attrs"
          text
          @click="snack = false"
        >
          Закрыть
        </v-btn>
      </template>
     </v-snackbar>

    </v-card>
  </template>

  <script>

  export default {

      data: () => ({

        delete_dialog: false,
        edit_dialog: false,
        edit_count: 0,

          headers: [
          {
              text: '№',
              align: 'start',
              value: 'rakami_p',
          },
          { text: 'Кол-во наименований', value: 'n_t' },
          { text: 'Кол-во товаров', value: 'k_t' },
          { text: 'Пользователь', value: 'fio' },
          { text: 'Дата', value: 'sana' },

          ],

          d_headers: [
          {
              text: 'Код',
              align: 'start',
              value: 'kod',
          },
          { text: 'Наименование', value: 'nom' },
          { text: 'Себестоимость', value: 'narkhi_a' },
          { text: 'Количество', value: 'kol' },
          { text: 'Действия', value: 'actions' },
          { text: 'id_mol', value: 'id_mol',  align: ' d-none' },


          ],

          json_fields: {

            'Код': 'kod',
            'Наименовние': 'nom' ,
            'Себестоимость': 'narkhi_a' ,
            'Количество': 'kol' ,
            },

           date1: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            menu: false,
            date2: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            menu2: false,

          peremeshenie: [],


          loading: false,

          snack: false,
          snackColor: '',
          snackText: '',

          search: '',
          id_mesto: 0,


          mikdorRules:[
            v => !!v || 'Обязательное поле',
            v=> (v && /[0-9]/.test(v)) || 'Неверный формат ввода',
            v => (v && /^\d*\.?\d*$/.test(v)) || 'Неверный формат ввода',
            ],


          mestaho: [
            {text: 'Все', value: 0},
            {text: 'В Магазин', value: 1},
            {text: 'На Склад', value: 2},
            ],



          MestoRules: [
            v => !!v || 'Выберите место',
          ],


          peremesheniho:true,
          d_peremesheniho:false,
          d_peremeshenie:[],
          rakam:0,



          export_molho_fields: [

            {
            'title': 'Код',
            'name': 'kod',
            'width': '20',
            'type': 'Number',
            },
            {
            'title': 'Наименование',
            'name': 'nom',
            'width': '50'

            },

            {
            'title': 'Закуп.цена',
            'name': 'narkhi_a',
            'type': 'float',
            'width': '15'
            },

            {
            'title': 'Количество',
            'name': 'kol',
            'type': 'float',
            'width': '15'
            },

            ],





      }),

      mounted(){
        this.get_peremeshenie();

      },

      methods: {

        get_peremeshenie(){


            this.peremesheniho = true;
            this.d_peremesheniho = false;

            this.loading = true;
              axios.get('/api/get_peremeshenies/1',
                      {
                          headers: {
                              "Content-type": "application/json"
                          }
                      })
                      .then(response => {
                              if(response.data.status){
                                  this.loading = false;
                                  this.peremeshenie = response.data.peremeshenies;
                              }else{
                                  this.loading = false;
                                  this.snack = true
                                  this.snackColor = 'error'
                                  this.snackText = "Ошибка получения peremeshenies"
                                  setTimeout(() => {
                                      this.snack = false;
                                  }, 2000);
                              }
                          })
                          .catch(error => {
                              this.loading = false;
                              this.snack = true
                              this.snackColor = 'error'
                              this.snackText = error.response.data.message;
                                  setTimeout(() => {
                                      this.snack = false;
                                  }, 2000);
                          });

        },

        filter_per(){

            this.$refs.menu.save(this.date1)
            this.$refs.menu2.save(this.date2)
            var from = this.date1;
            var to = this.date2;
            var mesto = this.id_mesto;
            var form = {
                from: from,
                to: to,
                mesto: 1,

            }

            this.peremeshenie = [];
            this.loading = true;
              axios.post('/api/post_peremeshenies', form,
                      {
                          headers: {
                              "Content-type": "application/json"
                          }
                      })
                      .then(response => {
                              if(response.data.status){
                                  this.loading = false;

                                  this.peremeshenie = response.data.peremeshenies;
                                  //console.log(response.data.peremeshenies);
                              }else{
                                  this.loading = false;
                                  this.snack = true
                                  this.snackColor = 'error'
                                  this.snackText = "Ошибка получения peremeshenies"
                                  setTimeout(() => {
                                      this.snack = false;
                                  }, 2000);
                              }
                          })
                          .catch(error => {
                              this.loading = false;
                              this.snack = true
                              this.snackColor = 'error'
                              this.snackText = error.response.data.message;
                                  setTimeout(() => {
                                      this.snack = false;
                                  }, 2000);
                          });

        },

        open_peremeshenie(event, {item}){

                this.peremesheniho = false;
                this.d_peremesheniho = true;
                this.rakam = item.rakami_p;
                this.get_rakam(item.rakami_p);

        },

        get_rakam(rakam){
            this.loading = true;
            axios.get('/api/get_rakam/' + rakam,
                      {
                          headers: {
                              "Content-type": "application/json"
                          }
                      })
                      .then(response => {
                              if(response.data.status){
                                  this.loading = false;
                                  this.d_peremeshenie = response.data.tovars;
                                  //console.log(response.data.peremeshenies);

                              }else{
                                  this.loading = false;
                                  this.snack = true
                                  this.snackColor = 'error'
                                  this.snackText = "Ошибка получения peremeshenies"
                                  setTimeout(() => {
                                      this.snack = false;
                                  }, 2000);
                              }
                          })
                          .catch(error => {
                              this.loading = false;
                              this.snack = true
                              this.snackColor = 'error'
                              this.snackText = error.response.data.message;
                                  setTimeout(() => {
                                      this.snack = false;
                                  }, 2000);
                          });

        },

        back(){

            this.peremesheniho = true;
            this.d_peremesheniho = false;
           // this.filter_per();
        },

        editItem(item){
            this.id_mol = item.id_mol;
            this.edit_dialog = true;
            this.edit_count = item.kol;
        },

        deleteItem(item){
            this.id_mol = item.id_mol;
            this.delete_dialog = true;
        },

        delete_confirm(){

            this.loading = true;
            axios.get('/api/delete_moved_mol/' + this.id_mol+ '/'+ this.rakam,

                      {
                          headers: {
                              "Content-type": "application/json"
                          }
                      })
                      .then(response => {
                              if(response.data.status){
                                  this.loading = false;
                                //remove from table
                                this.get_rakam(this.rakam);
                                this.d_peremeshenie = this.d_peremeshenie.filter((item) => {
                                    return item.id_mol !== this.id_mol;
                                });
                                this.snack = true
                                this.snackColor = 'success'
                                this.snackText = response.data.message;
                                  setTimeout(() => {
                                      this.snack = false;
                                  }, 2000);

                               //   console.log(response.data.message);
                                  this.delete_dialog = false;

                              }else{
                                  this.loading = false;
                                  this.snack = true
                                  this.snackColor = 'error'
                                  this.snackText = "Ошибка получения peremeshenies"
                                  setTimeout(() => {
                                      this.snack = false;
                                  }, 2000);
                              }
                          })
                          .catch(error => {
                              this.loading = false;
                              this.snack = true
                              this.snackColor = 'error'
                              this.snackText = error.response.data.message;
                                  setTimeout(() => {
                                      this.snack = false;
                                  }, 2000);
                          });

        },

        edit_confirm(){

            this.loading = true;
            axios.get('/api/edit_moved_mol/' + this.id_mol + "/" + this.edit_count +'/'+ this.rakam,
                      {
                          headers: {
                              "Content-type": "application/json"
                          }
                      })
                      .then(response => {
                              if(response.data.status){
                                  this.loading = false;
                                  this.edit_dialog = false;
                                  this.snack = true
                                    this.snackColor = 'success'
                                    this.snackText = response.data.message;
                                      setTimeout(() => {
                                          this.snack = false;
                                      }, 2000);

                                this.get_rakam(this.rakam);
                                // this.d_peremeshenie = this.d_peremeshenie.map((item) => {
                                //     if(item.id_mol === this.id_mol){
                                //         item.kol = this.edit_count;
                                //     }
                                //     return item;
                                // });

                                this.snack = true
                                this.snackColor = 'success'
                                this.snackText = response.data.message;
                                  setTimeout(() => {
                                      this.snack = false;
                                  }, 2000);

                               //   console.log(response.data.message);
                                  this.delete_dialog = false;

                              }else{
                                  this.loading = false;
                                  this.snack = true
                                  this.snackColor = 'error'
                                  this.snackText = "Ошибка получения peremeshenies"
                                  setTimeout(() => {
                                      this.snack = false;
                                  }, 2000);
                              }
                          })
                          .catch(error => {
                              this.loading = false;
                              this.snack = true
                              this.snackColor = 'error'
                              this.snackText = error.response.data.message;
                                  setTimeout(() => {
                                      this.snack = false;
                                  }, 2000);
                          });

        },


        startDownload(){
          console.log('show loading');
        },

        finishDownload(){
            console.log('hide loading');
        },

        search_enter(){
            var search = this.search;
            this.peremeshenie = [];

          //  this.$refs.menu.save(this.date1)
          //  this.$refs.menu2.save(this.date2)
            var from = this.date1;
            var to = this.date2;
            var mesto = this.id_mesto;
            var form = {
                from: from,
                to: to,
                mesto: 1,
                search: search

            }

            this.peremeshenie = [];
            this.loading = true;
              axios.post('/api/post_peremeshenies_kod', form,
                      {
                          headers: {
                              "Content-type": "application/json"
                          }
                      })
                      .then(response => {
                              if(response.data.status){
                                  this.loading = false;

                                  this.peremeshenie = response.data.peremeshenies;
                                  //console.log(response.data.peremeshenies);
                              }else{
                                  this.loading = false;
                                  this.snack = true
                                  this.snackColor = 'error'
                                  this.snackText = "Ошибка получения peremeshenies"
                                  setTimeout(() => {
                                      this.snack = false;
                                  }, 2000);
                              }
                          })
                          .catch(error => {
                              this.loading = false;
                              this.snack = true
                              this.snackColor = 'error'
                              this.snackText = error.response.data.message;
                                  setTimeout(() => {
                                      this.snack = false;
                                  }, 2000);
                          });

                          this.search = '';



        }


      }

  }
  </script>

<style  scoped>

</style>



